import { CognitoUserPool } from 'amazon-cognito-identity-js';

const poolData = {
  UserPoolId: 'eu-west-1_bMqbpGGKx',
  ClientId: '13qbj5gknpqege0pfpvaq8okm1',
};

export default new CognitoUserPool(poolData);
